import { render } from "./search-page.vue?vue&type=template&id=3a8a1d5b&scoped=true"
import script from "./search-page.vue?vue&type=script&lang=js"
export * from "./search-page.vue?vue&type=script&lang=js"

import "./search-page.vue?vue&type=style&index=0&id=3a8a1d5b&scoped=true&lang=css"
import "./search-page.vue?vue&type=style&index=1&id=3a8a1d5b&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a8a1d5b"]])

export default __exports__